import React, { useState } from 'react'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer/LayoutContainer'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import TextButton from 'components/Luxkit/Button/TextButton'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import useFlightDeals from 'hooks/Flights/useFlightDeals'
import FlightDealTile from 'components/Flights/FlightMerchandising/FlightDealTile'
import FlightDealAirportSelect from './ContentfulFlightDealAirportSelect'

const CarouselContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function ContentfulFlightDealsCarousel({ title, category, originAirportCodes, destinationAirportCode, viewAllLink }: Omit<App.ContentfulWebPageFlightDealsCarousel, 'contentTypeId'>) {
  const [selectedAirport, setSelectedAirport] = useState<string>(originAirportCodes.length > 0 ? originAirportCodes[0] : '')

  const filters = {
    ...(selectedAirport) && { originAirportCode: selectedAirport },
    ...(destinationAirportCode) && { destinationAirportCode },
  }
  const [flightDeals, fetching] = useFlightDeals(category, filters)

  return (
    <CarouselContainer>
      <VerticalSpacer gap={32}>
        <Group direction="horizontal" horizontalAlign="space-between" gap={8}>
          <Group direction="horizontal" gap={8}>
            <Heading variant="heading2" dangerouslySetInnerHTML={{ __html: title }}></Heading>
            {selectedAirport && originAirportCodes.length > 1 &&
              <FlightDealAirportSelect
              selected={selectedAirport}
              airports={originAirportCodes}
              onChange={setSelectedAirport}
            />
          }
          </Group>
          {viewAllLink && <TextButton href={viewAllLink} kind="tertiary" size="medium" shape="square">View all</TextButton>}
        </Group>
        <VerticalSpacer gap={2}>
          <CardCarousel pageSize={3}>
            {!fetching && flightDeals.map((flightDeal, index) => (
              <FlightDealTile position={index} key={flightDeal.id} flightDeal={flightDeal}/>
            ))}
          </CardCarousel>
        </VerticalSpacer>
      </VerticalSpacer>
    </CarouselContainer>
  )
}

export default ContentfulFlightDealsCarousel
